import React, { useState } from "react";
import { useRoutes, NavLink } from "react-router-dom";

import PanasonicImage from "../../assets/images/client-logo-panasonic.png";
import MakeMyTripImage from "../../assets/images/client-logo-make-my-trip.png";
import SodexoImage from "../../assets/images/client-logo-sodexo.png";
import TataImage from "../../assets/images/client-logo-tata.png";
import EyImage from "../../assets/images/client-logo-ey.png";
import PeaceChannelImage from "../../assets/images/client-logo-peace-channel.png";
import CanonImage from "../../assets/images/client-logo-canon.png";
import BMWImage from "../../assets/images/client-logo-bmw.png";
import MahindraRiseImage from "../../assets/images/client-logo-mahindra-rise.png";
import AirtelImage from "../../assets/images/client-logo-airtel.png";
import ITCImage from "../../assets/images/client-logo-itc.png";
import IIMAhamadabadImage from "../../assets/images/client-logo-iim-ahamadabad.png";
import LemonTreeHotelImage from "../../assets/images/client-logo-lemon-tree-hotel.png";
import WurthImage from "../../assets/images/client-logo-wurth.png";
import DellImage from "../../assets/images/client-logo-dell.png";
import SimenseImage from "../../assets/images/client-logo-simense.png";
import CarrefourImage from "../../assets/images/client-logo-carrefour.png";
import BimtechImage from "../../assets/images/client-logo-bimtech.png";
import RamcoImage from "../../assets/images/client-logo-ramco.png";
// import Image from  '../../assets/images/client-logo-.png';

const Services = () => {
  const customGridTemplateColumns = "repeat(4, 1fr)";
  return (
    <>
      <section className="_border-top" id="why">
        <div className="max-container">
          <div className="padd-90">
            <h2 className="text-center roboto-bold mb40 heading29px ">
              Some of our satisfied clients
            </h2>

            <div
              className="grid-auto-fit"
              style={{ "--grid-columns": customGridTemplateColumns }}
            >
              <div className="clients-box common-shadow">
                <img
                  src={PeaceChannelImage}
                  alt="Clients"
                  class="img-responsive"
                />
              </div>
              <div className="clients-box common-shadow">
                <img src={CanonImage} alt="Clients" class="img-responsive" />
              </div>
              <div className="clients-box common-shadow">
                <img src={EyImage} alt="Clients" class="img-responsive" />
              </div>
              <div className="clients-box common-shadow">
                <img
                  src={MakeMyTripImage}
                  alt="Clients"
                  class="img-responsive"
                />
              </div>

              <div className="clients-box common-shadow">
                <img src={BMWImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img
                  src={PanasonicImage}
                  alt="Clients"
                  class="img-responsive"
                />
              </div>

              <div className="clients-box common-shadow">
                <img
                  src={MahindraRiseImage}
                  alt="Clients"
                  class="img-responsive"
                />
              </div>

              <div className="clients-box common-shadow">
                <img src={AirtelImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img src={ITCImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img
                  src={IIMAhamadabadImage}
                  alt="Clients"
                  class="img-responsive"
                />
              </div>

              <div className="clients-box common-shadow">
                <img
                  src={LemonTreeHotelImage}
                  alt="Clients"
                  class="img-responsive"
                />
              </div>

              <div className="clients-box common-shadow">
                <img src={WurthImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img src={DellImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img src={SimenseImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img src={TataImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img src={SodexoImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img
                  src={CarrefourImage}
                  alt="Clients"
                  class="img-responsive"
                />
              </div>

              <div className="clients-box common-shadow">
                <img src={BimtechImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img src={RamcoImage} alt="Clients" class="img-responsive" />
              </div>

              <div className="clients-box common-shadow">
                <img src={TataImage} alt="Clients" class="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Services;
